import {AppPageElement} from './app.page.element';
/**
 * 模块配置节点
 */
export class AppPageTemplateConotent {
    constructor(){
this.element = new Array<AppPageElement>();
    }
    /**
     * 模块名称
     */
    name: string;
    /**
     * 模块样式
     */
    class: string;
    /**
     * 指定的xml名称,或者数据库表名或者视图名称,默认匹配xml名称,如果匹配不到则默认当作表名/视图名。
     */
    configName: string;
    /**
     * 请求api地址,如果不存在就默认为系统默认地址
     */
    dataApiUrl: string;
    /**
     * 设置控件高度
     */
    height: string;
    /**
     * 过渡之间的延迟(以毫秒为单位)。如果没有传递这个参数，则禁用自动播放，默认为”null“不自动播放
     */
    autoplay: string;
    /**
     * 幻灯片在屏幕中央
     */
    centeredSlides: boolean;
    /**
     * 通过另一个幻灯片实例或者幻灯片实例的数组，这些实例应该由这个幻灯片实例来控制。默认为“null”
     */
    control: string;
    /**
     * 如果dir属性等于rtl，将interal rtl设置为true
     */
    dir: string;
    /**
     * 滑动方向，水平(horizontal)或垂直(vertical)
     */
    direction: string;
    /**
     * 幻灯片的动画效果,效果为"slide"--滑动, "fade"--渐变, "cube"--立方体,
     *  "coverflow" or "flip"--覆盖或翻转.默认为"slide"滑动
     */
    effect: string;
    /**
     * 初始化时slide的索引
     */
    initialSlide: number;
    /**
     * 循环滑动
     */
    loop: boolean;
    /**
     * 导航小圆点
     */
    pager: boolean;
    /**
     * 分页类型，类型有“bullets“, ”fraction“, ”progress” 默认为“bullets”
     * (注意，除非pager设置为true，否则类型不会显示）
     */
    paginationType: string;
    /**
     * 如果设置为“true”允许您使用滑块内部的“parallax”元素
     */
    parallax: boolean;
    /**
     * 同时显示slide数量
     */
    slidesPerView: number;
    /**
     * slide之间设置距离，以“PX”计算，默认0
     */
    spaceBetween: number;
    /**
     * slider自动滑动开始到结束的时间（毫秒为单位），默认值300
     */
    speed: number;
    /**
     * 当前模块所包含的控件模块，相当于xml的Element节点
     */
    element: Array<AppPageElement>;
    /**
     * 当前element节点是否存在
     */
    elementListIsEmpty: boolean;
    /**
     * 请求表的主键
     */
    idField: string;
}